import React from "react";
import { Button } from "../../Shared/Buttons/Button/Button";

export type AuthErrorProps = {
  onRetry: () => void;
};

/**
 * Rendered when the startup auth/token check settles without a valid token
 * (expired, unauthenticated, or an error). Provider-free so it can render
 * before the context providers mount, mirroring PageLoader.
 */
export function AuthError({ onRetry }: Readonly<AuthErrorProps>) {
  return (
    <div
      role="alert"
      className="flex h-screen w-full flex-col items-center justify-center gap-4 p-6 text-center text-primary-color"
    >
      <h1 className="text-collins-lg font-bold">
        We couldn&apos;t sign you in
      </h1>
      <p className="max-w-md text-collins-md">
        Your session may have expired or you are not signed in. Please try
        again.
      </p>
      <Button type="primary" name="Try again" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
